import {browserStorageKey} from '../constants/browserStorageKey';
import {getWorktreeName} from './getWorktreeName';

/**
 * Points every later API request at the given backend worktree, or at the main backend app when
 * passed `null`. Returns `true` when the target actually changed, i.e. the caller should send the
 * user through login.
 *
 * Sessions do not survive the switch: the access token is signed with a key shared by all
 * worktrees and would keep working for hours, but refresh tokens live in each worktree's own
 * database, so the next refresh would fail with a logout that looks random. Both tokens are
 * therefore dropped here.
 *
 * The cleared state is stored as an empty string rather than removed, so `getWorktreeLoginParams`
 * still forwards it and IAM drops its own override instead of keeping the last worktree.
 */
export function setWorktreeOverride(worktreeName: string | null): boolean {
  if (getWorktreeName() === worktreeName) {
    return false;
  }

  localStorage.setItem(browserStorageKey.WORKTREE_NAME, worktreeName ?? '');
  sessionStorage.removeItem(browserStorageKey.ACCESS_TOKEN);
  localStorage.removeItem(browserStorageKey.REFRESH_TOKEN);

  return true;
}
